import { addGetAddressListeners } from './checkout';
import { CustomCheckoutFieldListeners } from './customCheckoutFields';
import {
  fadeIn,
  fadeInText,
  fadeOut,
  fadeOutText,
  hide,
  unHide,
} from './modules/animations';
import {
  collapseAndDisableSection,
  defaultListeners,
  expandAndEnableSection
} from './modules/collapse';
import { cookieListeners } from './modules/cookie';
import { addErrorLogger } from './modules/onerror';
import { popupListeners } from './modules/popup';

addErrorLogger();

document.addEventListener('DOMContentLoaded', () => {
  cookieListeners();
  defaultListeners(
    (collapsible, toggle) => {
      toggle.classList.add('rotate-180');
    },
    (collapsible, toggle) => {
      toggle.classList.remove('rotate-180');
    }
  );
  popupListeners();
  addMenuListeners();
  addListenersPlusMinusButtons();
  addGetAddressListeners();
  addWineListeners();
  addWinePopupListeners();
  addAddToCartPopupListeners();
  CustomCheckoutFieldListeners();
  AddLocationListeners();

  document.querySelectorAll('[id^="scrollTo-"]').forEach((element) => {
    let target = element.id.replace('scrollTo-', '');

    target = document.getElementById(target);

    element.addEventListener('click', () => {
      scrollTo(target, 100);
    });
  });
});

function addAddToCartPopupListeners() {
  const popupContainer = document.getElementById('popup-container-add-to-cart');

  if (!popupContainer) {
    return;
  }
  popupContainer.addEventListener('click', (e) => {
    if (e.target == popupContainer) {
      fadeOut(popupContainer);
    }
  });

  document.querySelectorAll('.add-to-cart-popup-close').forEach((button) => {
    button.addEventListener('click', () => {
      fadeOut(popupContainer);
    });
  });
}

function addWinePopupListeners() {
  document.querySelectorAll("[id^='wine-button-']").forEach((popupButton) => {
    const productId = popupButton.id.replace('wine-button-', '');
    const popup = document.getElementById('wine-popup-' + productId);
    const popupClose = document.getElementById('wine-popup-close-' + productId);
    popupButton.addEventListener('click', () => {
      fadeIn(popup);
    });
    popup.addEventListener('click', (e) => {
      if (e.target == popup) {
        fadeOut(popup);
      }
    });
    popupClose.addEventListener('click', (e) => {
      fadeOut(popup);
    });
  });
}

function addWineListeners() {
  const kruiden = document.getElementById('kruiden');
  const gewicht = document.getElementById('gewicht');
  const glutenvrij = document.getElementById('glutenvrij');
  const gekruid = document.getElementById('gekruid');
  if (!gewicht) {
    return;
  }

  if (!kruiden) {
    const wineOngevuld = document.getElementById('wine-zoet');
    // const wine = document.getElementById('wine-hartig');
    const productOrderButtonDisabled = document.getElementById(
      'product-order-button-disabled'
    );
    const productOrderButtonActive = document.getElementById(
      'product-order-button-active'
    );
    // const productVariant = document.getElementById('product-variant');

    // productVariant.innerHTML = 'ongekruide';
    fadeInText(wine);
    // expandAndEnableSection(wine);
    expandAndEnableSection(wineOngevuld);
    // wine - zoet;
    fadeOut(productOrderButtonActive)
      .then(async () => {
        hide(productOrderButtonActive);
        unHide(productOrderButtonDisabled);
        return;
      })
      .then(fadeIn(productOrderButtonDisabled));

    gewicht.addEventListener('change', () => {
      determineProductOrderButton(gewicht, glutenvrij, gekruid);
    });
    glutenvrij?.addEventListener('change', () => {
      determineProductOrderButton(gewicht, glutenvrij, gekruid);
    });
    gekruid?.addEventListener('change', () => {
      determineProductOrderButton(gewicht, glutenvrij, gekruid);
    });
    return;
  }
  showWine(kruiden, gewicht, glutenvrij, gekruid);

  kruiden.addEventListener('change', () => {
    showWine(kruiden, gewicht, glutenvrij, gekruid);
  });
  gewicht.addEventListener('change', () => {
    showWine(kruiden, gewicht, glutenvrij, gekruid);
  });
  glutenvrij?.addEventListener('change', () => {
    showWine(kruiden, gewicht, glutenvrij, gekruid);
  });
  gekruid?.addEventListener('change', () => {
    showWine(kruiden, gewicht, glutenvrij, gekruid);
  });
}

async function determineProductOrderButton(gewicht, glutenvrij, gekruid) {
  const productOrderButton = document.getElementById('product-order-button');
  const productOrderButtonDisabled = document.getElementById(
    'product-order-button-disabled'
  );
  const productOrderButtonActive = document.getElementById(
    'product-order-button-active'
  );
  if (gewicht?.value == '' || glutenvrij?.value == '' || gekruid?.value == '') {
    productOrderButton.disabled = true;
    fadeOut(productOrderButtonActive)
      .then(async () => {
        hide(productOrderButtonActive);
        unHide(productOrderButtonDisabled);
        return;
      })
      .then(fadeIn(productOrderButtonDisabled));
  } else {
    productOrderButton.disabled = false;
    fadeOut(productOrderButtonDisabled)
      .then(async () => {
        hide(productOrderButtonDisabled);
        unHide(productOrderButtonActive);
        return;
      })
      .then(fadeIn(productOrderButtonActive));
  }
}

async function showWine(kruiden, gewicht, glutenvrij, gekruid) {
  const wine = document.getElementById('wine');
  const wineHartig = document.getElementById('wine-hartig');
  const wineZoet = document.getElementById('wine-zoet');
  const productOrderButton = document.getElementById('product-order-button');
  const productOrderButtonDisabled = document.getElementById(
    'product-order-button-disabled'
  );
  const productOrderButtonActive = document.getElementById(
    'product-order-button-active'
  );

  if (
    kruiden.value == '' ||
    gewicht.value == '' ||
    glutenvrij.value == '' ||
    gekruid.value == ''
  ) {
    productOrderButton.disabled = true;
    fadeOut(productOrderButtonActive)
      .then(async () => {
        hide(productOrderButtonActive);
        unHide(productOrderButtonDisabled);
        return;
      })
      .then(fadeIn(productOrderButtonDisabled));
  } else {
    productOrderButton.disabled = false;
    fadeOut(productOrderButtonDisabled)
      .then(async () => {
        hide(productOrderButtonDisabled);
        unHide(productOrderButtonActive);
        return;
      })
      .then(fadeIn(productOrderButtonActive));
  }

  // const productVariant = document.getElementById('product-variant');

  if (kruiden.value == '') {
    fadeOutText(wine);
    collapseAndDisableSection(wine);
    fadeOut(wineZoet);
    fadeOut(wineHartig);
    collapseAndDisableSection(wineZoet);
    collapseAndDisableSection(wineHartig);
    return;
  }

  fadeInText(wine);
  expandAndEnableSection(wine);

  if (kruiden.value.includes('Hartig')) {
    // fadeOut(wineZoet);
    fadeIn(wineZoet);
    // expandAndEnableSection(wineHartig);
    expandAndEnableSection(wineZoet);

    // productVariant.innerHTML = 'hartig gevulde';
  }

  if (kruiden.value.includes('Zoet')) {
    fadeOut(wineHartig);
    fadeIn(wineZoet);
    expandAndEnableSection(wineZoet);
    collapseAndDisableSection(wineHartig);

    // productVariant.innerHTML = 'zoet gevulde';
  }
}

function addListenersPlusMinusButtons() {
  const inputsProductCards = document.querySelectorAll('.product-quantity');
  inputsProductCards.forEach((input) => {
    let target = input.querySelector('.button-minus');
    if (target) {
      target.addEventListener('click', () => {
        let realInput = input.querySelector('input');
        let newValue = Math.max(0, parseInt(realInput.value) - 1);

        // let buyButton = input.querySelector("a");
        // var href = new URL(buyButton.href);

        // href.searchParams.set("quantity", newValue);
        realInput.value = newValue;
        // buyButton.href = href.toString();
      });
    }

    target = input.querySelector('.button-plus');
    if (target) {
      target.addEventListener('click', () => {
        let realInput = input.querySelector('input');
        let newValue = Math.max(0, parseInt(realInput.value) + 1);

        // let buyButton = input.querySelector("a");
        // var href = new URL(buyButton.href);

        // href.searchParams.set("quantity", newValue);
        realInput.value = newValue;
        // buyButton.href = href.toString();
      });
    }
  });

  // const inputsProductCheckout = document.querySelectorAll(".product-quantity-checkout");
  // inputsProductCheckout.forEach((input) => {
  //   let target = input.querySelector("[id ^= 'button-minus-']");
  //   if (target) {
  //     target.addEventListener("click", () => {
  //       let realInput = input.querySelector("input");
  //       let newValue = Math.max(10, parseInt(realInput.value) - 1);

  //       realInput.value = newValue;
  //       document.getElementById("cart-update-button").classList.remove("bg-opacity-50");
  //     });
  //   }

  //   target = input.querySelector("[id ^= 'button-plus-']");
  //   if (target) {
  //     target.addEventListener("click", () => {
  //       let realInput = input.querySelector("input");
  //       let newValue = Math.max(10, parseInt(realInput.value) + 1);

  //       realInput.value = newValue;
  //       document.getElementById("cart-update-button").classList.remove("bg-opacity-50");
  //     });
  //   }
  // });
}

function addMenuListeners() {
  const navBar = document.getElementById('nav-bar');
  window.addEventListener('scroll', () => {
    toggleMenuBg(navBar);
  });
  toggleMenuBg(navBar);
}

function toggleMenuBg(navBar) {
  if (window.scrollY > 10) {
    navBar.classList.add('bg-opacity-90');
  }

  // if scroll up by more then 5px (so trackpads wont be weird) open ticker
  if (window.scrollY <= 10) {
    navBar.classList.remove('bg-opacity-90');
  }
}

function AddLocationListeners() {
  document
    .querySelectorAll("input[id^='afhaal_locatie_']")
    .forEach((selector) => {
      selector.addEventListener('click', () => {
        openRightMomentSelector(selector);
      });
      if (selector.checked) {
        openRightMomentSelector(selector);
      }
    });
}

function openRightMomentSelector(selector) {
  if (selector.id.includes('Poelier')) {
    collapseAndDisableSection(
      document.getElementById('afhaal-moment-nieuwkoop')
    );
    collapseAndDisableSection(
      document.getElementById('afhaal-moment-amsterdam')
    );
    expandAndEnableSection(document.getElementById('afhaal-moment-poelier'));
  }

  if (selector.id.includes('Nieuwkoop')) {
    expandAndEnableSection(document.getElementById('afhaal-moment-nieuwkoop'));
    collapseAndDisableSection(
      document.getElementById('afhaal-moment-amsterdam')
    );
    collapseAndDisableSection(document.getElementById('afhaal-moment-poelier'));
  }

  if (selector.id.includes('Buitenveldert')) {
    collapseAndDisableSection(
      document.getElementById('afhaal-moment-nieuwkoop')
    );
    expandAndEnableSection(document.getElementById('afhaal-moment-amsterdam'));
    collapseAndDisableSection(document.getElementById('afhaal-moment-poelier'));
  }
}

function scrollTo(element, offset = 0) {
  if (!element) {
    return;
  }

  var top = element.offsetTop - offset;

  console.debug(top);

  window.scrollTo({
    behavior: 'smooth',
    left: 0,
    top: top,
  });

  return;
}
